module.exports = __webpack_public_path__ + "static/img/5.5342bec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/landing/5.jpg
// module id = A1OO
// module chunks = 0